import { LoanMergeParams } from 'app/models/loan-merge-params'
import { approveSelectedLoanMerge, deleteSelectedLoanMerge, loadAllLoanMerges, rejectSelectedLoanMerge, submitForApproval } from 'app/state/ducks/loan-merges/thunks'
import {
  ErrorNotification,
  SuccessNotification,
} from 'app/views/components/notifications/notification'
import { Dispatch } from 'redux'

export async function submitLoanMerge(
  loanMerge: LoanMergeParams,
  dispatch: Dispatch<any>
) {
  const response: any = await dispatch(submitForApproval(loanMerge))
  if (response.success) {
    SuccessNotification({
      title: 'Successful Submission',
      message: 'Loan Merge has been Submitted for Approval',
    })
  } else {
    ErrorNotification({
      title: 'Submission Failed',
      message: response.payload ?? 'Could not submit Loan Merge',
    })
  }
  dispatch(loadAllLoanMerges())
  return
}

export async function rejectLoanMerge(
  loanMerge: LoanMergeParams,
  dispatch: Dispatch<any>
) {
  const response: any = await dispatch(rejectSelectedLoanMerge(loanMerge))
  if (response.success) {
    SuccessNotification({
      title: 'Successful Rejection',
      message: 'Loan Merge has been moved back to a Draft',
    })
  } else {
    ErrorNotification({
      title: 'Rejection Failed',
      message: response.payload ?? 'Could not reject Loan Merge',
    })
  }
  dispatch(loadAllLoanMerges())
  return
}

export async function approveLoanMerge(
  loanMerge: LoanMergeParams,
  dispatch: Dispatch<any>
) {
  const response: any = await dispatch(
    approveSelectedLoanMerge(loanMerge)
  )
  if (response.success) {
    SuccessNotification({
      title: 'Successful Approval',
      message: 'Loan Merge has been Approved',
    })
  } else {
    ErrorNotification({
      title: 'Approval Failed',
      message: response.payload ?? 'Could not approve Loan Merge',
    })
  }
  dispatch(loadAllLoanMerges())
  return
}

export async function deleteLoanMerge(
  loanMerge: LoanMergeParams,
  dispatch: Dispatch<any>
) {
  const response: any = await dispatch(deleteSelectedLoanMerge(loanMerge))
  if (response.payload.error) {
    ErrorNotification({
      title: 'Delete Failed',
      message: response.payload.error.message,
    })
  } else {
    SuccessNotification({
      title: 'Successful Deletion',
      message: 'Loan Merge has been Deleted',
    })
  }
  dispatch(loadAllLoanMerges())
  return
}